import { render, staticRenderFns } from "./DossierWiki.vue?vue&type=template&id=4fbeec94"
import script from "./DossierWiki.vue?vue&type=script&lang=js"
export * from "./DossierWiki.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports